/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProposalSummaryFeeDisinvestmentInstructions } from './ProposalSummaryFeeDisinvestmentInstructions';
import {
    ProposalSummaryFeeDisinvestmentInstructionsFromJSON,
    ProposalSummaryFeeDisinvestmentInstructionsFromJSONTyped,
    ProposalSummaryFeeDisinvestmentInstructionsToJSON,
} from './ProposalSummaryFeeDisinvestmentInstructions';
import type { ProposalSummaryFundDetailsCollectiveInvestments } from './ProposalSummaryFundDetailsCollectiveInvestments';
import {
    ProposalSummaryFundDetailsCollectiveInvestmentsFromJSON,
    ProposalSummaryFundDetailsCollectiveInvestmentsFromJSONTyped,
    ProposalSummaryFundDetailsCollectiveInvestmentsToJSON,
} from './ProposalSummaryFundDetailsCollectiveInvestments';
import type { ProposalSummaryJustIncomePortfolio } from './ProposalSummaryJustIncomePortfolio';
import {
    ProposalSummaryJustIncomePortfolioFromJSON,
    ProposalSummaryJustIncomePortfolioFromJSONTyped,
    ProposalSummaryJustIncomePortfolioToJSON,
} from './ProposalSummaryJustIncomePortfolio';
import type { ProposalSummaryPhaseInInstructions } from './ProposalSummaryPhaseInInstructions';
import {
    ProposalSummaryPhaseInInstructionsFromJSON,
    ProposalSummaryPhaseInInstructionsFromJSONTyped,
    ProposalSummaryPhaseInInstructionsToJSON,
} from './ProposalSummaryPhaseInInstructions';
import type { ProposalSummaryRegularWithdrawalInstructions } from './ProposalSummaryRegularWithdrawalInstructions';
import {
    ProposalSummaryRegularWithdrawalInstructionsFromJSON,
    ProposalSummaryRegularWithdrawalInstructionsFromJSONTyped,
    ProposalSummaryRegularWithdrawalInstructionsToJSON,
} from './ProposalSummaryRegularWithdrawalInstructions';

/**
 * 
 * @export
 * @interface ProposalSummaryFundDetails
 */
export interface ProposalSummaryFundDetails {
    /**
     * 
     * @type {Array<ProposalSummaryFundDetailsCollectiveInvestments>}
     * @memberof ProposalSummaryFundDetails
     */
    collectiveInvestments: Array<ProposalSummaryFundDetailsCollectiveInvestments>;
    /**
     * 
     * @type {ProposalSummaryPhaseInInstructions}
     * @memberof ProposalSummaryFundDetails
     */
    phaseInInstructions?: ProposalSummaryPhaseInInstructions;
    /**
     * 
     * @type {ProposalSummaryRegularWithdrawalInstructions}
     * @memberof ProposalSummaryFundDetails
     */
    regularWithdrawalInstructions?: ProposalSummaryRegularWithdrawalInstructions;
    /**
     * 
     * @type {ProposalSummaryFeeDisinvestmentInstructions}
     * @memberof ProposalSummaryFundDetails
     */
    feeDisinvestmentInstructions?: ProposalSummaryFeeDisinvestmentInstructions;
    /**
     * 
     * @type {ProposalSummaryJustIncomePortfolio}
     * @memberof ProposalSummaryFundDetails
     */
    justIncomePortfolio?: ProposalSummaryJustIncomePortfolio;
}

/**
 * Check if a given object implements the ProposalSummaryFundDetails interface.
 */
export function instanceOfProposalSummaryFundDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "collectiveInvestments" in value;

    return isInstance;
}

export function ProposalSummaryFundDetailsFromJSON(json: any): ProposalSummaryFundDetails {
    return ProposalSummaryFundDetailsFromJSONTyped(json, false);
}

export function ProposalSummaryFundDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalSummaryFundDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'collectiveInvestments': ((json['CollectiveInvestments'] as Array<any>).map(ProposalSummaryFundDetailsCollectiveInvestmentsFromJSON)),
        'phaseInInstructions': !exists(json, 'PhaseInInstructions') ? undefined : ProposalSummaryPhaseInInstructionsFromJSON(json['PhaseInInstructions']),
        'regularWithdrawalInstructions': !exists(json, 'RegularWithdrawalInstructions') ? undefined : ProposalSummaryRegularWithdrawalInstructionsFromJSON(json['RegularWithdrawalInstructions']),
        'feeDisinvestmentInstructions': !exists(json, 'FeeDisinvestmentInstructions') ? undefined : ProposalSummaryFeeDisinvestmentInstructionsFromJSON(json['FeeDisinvestmentInstructions']),
        'justIncomePortfolio': !exists(json, 'JustIncomePortfolio') ? undefined : ProposalSummaryJustIncomePortfolioFromJSON(json['JustIncomePortfolio']),
    };
}

export function ProposalSummaryFundDetailsToJSON(value?: ProposalSummaryFundDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'CollectiveInvestments': ((value.collectiveInvestments as Array<any>).map(ProposalSummaryFundDetailsCollectiveInvestmentsToJSON)),
        'PhaseInInstructions': ProposalSummaryPhaseInInstructionsToJSON(value.phaseInInstructions),
        'RegularWithdrawalInstructions': ProposalSummaryRegularWithdrawalInstructionsToJSON(value.regularWithdrawalInstructions),
        'FeeDisinvestmentInstructions': ProposalSummaryFeeDisinvestmentInstructionsToJSON(value.feeDisinvestmentInstructions),
        'JustIncomePortfolio': ProposalSummaryJustIncomePortfolioToJSON(value.justIncomePortfolio),
    };
}

